import { useProject } from '../../project/project-hooks/useProject';
import { useEffect, useRef, useState } from 'react';
import ThemeContainer from '../../components/theme-container/ThemeContainer';
import { THEMES } from '../../utils/cms-utils';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import Image from '../../components/image/Image';
import { Heading2 } from '@sb1/ffe-core-react';
import { userOwnsProject } from '../../project/project-model';
import RoundedButtonLinkAction from '../../components/button/rounded-button-link-action/RoundedButtonLinkAction';
import { useUser } from '../../user/useUser';
import styles from './ftf-projectbanner.module.less';
import { formatMoneyKr } from '../../utils';
import RoundedButtonAction from '../../components/button/rounded-button-action/RoundedButtonAction';
import { Modal, ModalBlock } from '@sb1/ffe-modals-react';
import RoundedButtonPrimary from '../../components/button/rounded-button-primary/RoundedButtonPrimary';

const FTFProjectBanner = () => {
    const project = useProject();
    const user = useUser();
    const [data, setData] = useState({});
    const modalRef = useRef();

    const standardOwnerName = project?.ownerInformation?.override?.name || project?.ownerInformation?.name;

    useEffect(() => {
        if (!project?.id) {
            return;
        }
        const level = project.profile.ftfSponsorLevel;
        if (level === 'gull') {
            setData({
                logo: 'campaign/fotballtroye/gullsponsor.svg',
                type: 'gullsponsor',
                description: 'Næringslivet står sammen i kampen mot barnekreft',
                amount: 75_000,
                text: `${standardOwnerName} er stolt gullsponsor av årets FotballtrøyeFredag`,
            });
        } else if (level === 'sølv') {
            setData({
                logo: 'campaign/fotballtroye/solvsponsor.svg',
                type: 'sølvsponsor',
                description: 'Næringslivet står sammen i kampen mot barnekreft',
                amount: 25_000,
                text: `${standardOwnerName} er stolt sølvsponsor av årets FotballtrøyeFredag`,
            });
        } else if (level === 'bronse') {
            setData({
                logo: 'campaign/fotballtroye/bronsesponsor.svg',
                type: 'bronsesponsor',
                description: 'Næringslivet står sammen i kampen mot barnekreft',
                amount: 5_000,
                text: `${standardOwnerName} er stolt bronsesponsor av årets FotballtrøyeFredag`,
            });
        } else if (level === 'støttespiller') {
            setData({
                logo: 'campaign/fotballtroye/stottespiller.svg',
                type: 'støttespiller',
                description: 'Næringslivet står sammen i kampen mot barnekreft',
                text: `${standardOwnerName} er stolt støttespiller av årets FotballtrøyeFredag`,
            });
        } else if (level === 'fotballklubb') {
            setData({
                logo: 'campaign/fotballtroye/supporter.svg',
                text: `${standardOwnerName} er stolt støttespiller av årets FotballtrøyeFredag`,
            });
        } else {
            setData({
                logo: 'campaign/fotballtroye/supporter.svg',
                description: 'Sammen i kampen mot barnekreft',
                text: 'Stolt supporter av FotballtrøyeFredag',
            });
        }
    }, [project.id]);

    if (userOwnsProject(project, user?.id) && data.amount > 0 && project.collected_amount < data.amount) {
        return (
            <ThemeContainer tag={'section'} mainColor={THEMES.FROST30} className={styles.banner}>
                <Image src={data.logo} className={styles.logo} />
                <div className={styles.textContainer}>
                    <Heading2 lookLike={5} noMargin>
                        Som {data.type} må du støtte spleisen med minimum {formatMoneyKr(data.amount)}
                    </Heading2>
                    {project.published_at ? (
                        <RoundedButtonLinkAction
                            to={`/project/${project.id}/payment?amount=${data.amount}&hideDefaultAmounts=true&name=${standardOwnerName}`}
                            target={'_blank'}
                            category={'project_banner_payment_ftf2025'}
                            action={'link_click'}
                            className={styles.button}
                        >
                            Gå til betaling
                        </RoundedButtonLinkAction>
                    ) : (
                        <RoundedButtonAction
                            category={'project_banner_not_published_ftf2025'}
                            action={'link_click'}
                            className={styles.button}
                            onClick={() => modalRef?.current?.open()}
                        >
                            Gå til betaling
                        </RoundedButtonAction>
                    )}
                </div>
                <Modal ref={modalRef}>
                    <ModalBlock>
                        <Heading2>Start spleisen først</Heading2>
                        <p>Du må starte spleisen før du kan gå til betaling</p>

                        <RoundedButtonPrimary className={styles.modalButton} onClick={() => modalRef?.current?.close()}>
                            Ok
                        </RoundedButtonPrimary>
                    </ModalBlock>
                </Modal>
            </ThemeContainer>
        );
    }

    return (
        <ThemeContainer tag={'section'} mainColor={THEMES.FROST30} className={styles.banner}>
            <Image src={data.logo} className={styles.logo} />
            <div className={styles.textContainer}>
                <Heading2 lookLike={5} noMargin>
                    {data.text}
                </Heading2>
                {data.description && <p className={styles.text}>{data.description}</p>}
                <TrackEventLink
                    to={`/fotballtrøyefredag`}
                    target={'_blank'}
                    category={'project_banner_ftf2025'}
                    action={'link_click'}
                >
                    Finn ut mer
                </TrackEventLink>
            </div>
        </ThemeContainer>
    );
};

export default FTFProjectBanner;
